/**
 * Returns a particular value corresponding to the state of a nullable boolean value.
 * @param value The value being checked.
 * @param trueVal The output value if the value is true.
 * @param falseVal The output value if the value is false.
 * @param nullVal The output value if the value is null.
 */
export function fromNullable<T>(
  value: boolean | null,
  trueVal: T,
  falseVal: T,
  nullVal: T): T {
  if (value === true) {
    return trueVal;
  } else if (value === false) {
    return falseVal;
  } else {
    return nullVal;
  }
}
